<template>
  <div class="landing-page snaliens">
    <div class="container white-text">
      <container class="white-text" title="About">
        <div class="container content columns is-mobile is-multiline padding">
          <vue-markdown class="markdown force snaliens" :source='about'> {{about}} </vue-markdown>   
        </div>
        </container>
      <container class="features" title="Features"> 
        <div class="is-size-5 container2 desktop">
          <topic class="snaliens" v-for="topic in topics" :key="topic.icon" :icon='topic.icon' :text='topic.text' :action='topic.action'/>
        </div>
      </container>
      <container class="med" title="Media"> 
        <div class="is-size-5 container content desktop">
          <div class="slides">
            <div class="slides2">
            <slides ref="slides" class="media" :media='media'/>
            </div>
          </div>
        </div>
      </container>
    </div>
    </div>
</template>

<script>
import container from "@/components/structure/Section.vue"
import VueMarkdown from 'vue-markdown'
import topic from "@/components/structure/Topic.vue"
import slides from '@/components/structure/Slides.vue'
export default {
  components:
  {
    container,
    topic,
    slides,
    VueMarkdown,
  },
  data(){
    return {
      about: 
      `A group of Snaliens just collapsed on an unexplored planet and now they need your help!
Help them to reunite and escape by solving intricate puzzles.
      `,
      topics: [
        {icon: 'Timer.svg', text: 'No Timers', action: null},
        {icon: 'levels.svg', text: '80+ Levels', action: null},
        {icon: 'NonLinear.svg', text: 'Non Linear', action: null},
        {icon: 'Snake.svg', text: 'Snake-Like Behaviour', action: this.showSkills},
        {icon: 'acessible.svg', text: 'Keyboard, Gamepad or Mouse', action: this.showSkills},
      ],
      media: 
      [
      "https://www.youtube.com/embed/PZecVaFgOzI?rel=0&amp;autoplay=1&mute=1", 
      "https://i.imgur.com/DCnzusn.png",
      "https://i.imgur.com/PmsLVQJ.png",
      "https://i.imgur.com/fPZ42yG.png",
      "https://i.imgur.com/E4VXZeK.png",
      "https://i.imgur.com/NlL7a2R.png",
      "https://i.imgur.com/sA6PNyw.png",
      "https://i.imgur.com/1kA95SB.png",
      "https://i.imgur.com/0heyw65.png",
      "https://i.imgur.com/fvCQSRp.png",
      ]
    }
  }

}
</script>

<style>
.snaliens .section .line
{
  background-color: #83A6BF;
}

.topic.snaliens .icon
{
  min-width: 4em;
  min-height: 4em;
  max-height: 4em;
  max-width: 4em;
}

</style>

<style scoped>

.white-text
{
  color: white;
}

.content .markdown
{
  font-size: 1.5em;
  width: 100%;
  text-align: center;
}




.content
{
  margin-left: 5em;
  margin-right: 5em;
  margin-bottom: 5em;
}

@media screen and (min-width:601px){
  .desktop{
    flex-direction: column;
  }
  .content
  {
    margin-left: 5em;
    margin-right: 5em;
  }
}

@media screen and (max-width:601px){
  .desktop{
    flex-direction: column !important;
    justify-content: center;
    align-items: center;
  }

  .content
  {
    margin-left: 1em;
    margin-right: 1em;
  }
}

.container
{
  color: white;
}

.container2{
  justify-content: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.topic{
  margin: 1em;
  margin-top: 0;
  font-size: 1.2em;
  width: 10em;
}

.slides{
  padding-top: 50%;
  width: 100%;
  background-color: red;
  position: relative;
}

.slides2
{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.landing-page
{
  background-color: #1F3764;
  background-color: var(--dark-color);
}



</style>